import { Box, useTheme } from '@chakra-ui/react'
import { BLOGS_BY_TAG as BLOGS_BY_TAG_PATH } from '@/routes'
import NextLink from 'next/link'

interface Props {
  id: number
  name: string
}

function Tag({ name, id }: Props): React.ReactElement {
  const theme = useTheme()

  return (
    <NextLink
      passHref
      href={{
        pathname: BLOGS_BY_TAG_PATH.pathname,
        query: {
          id,
        },
      }}
    >
      <Box
        as="a"
        sx={{
          borderRadius: '4px',
          border: `1px solid ${theme.colors.secondary[800]}`,
          padding: '4px 8px',
          fontSize: '12px',
          fontWeight: '500',
          '&:hover': {
            color: theme.colors.primary[400],
            border: `1px solid ${theme.colors.primary[400]}`,
          },
        }}
      >
        {name}
      </Box>
    </NextLink>
  )
}

export default Tag
